import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { StyledTableCell } from "./StyledTableCell";
import { StyledTableRow } from "./StyledTableRow";

export const RowTable = ({ values, children }) => {
  return (
    <StyledTableRow>
      <StyledTableCell
        style={{ fontWeight: "bold" }}
        component="th"
        scope="row"
      >
        {children}
      </StyledTableCell>
      <StyledTableCell align="center">{values[0]}</StyledTableCell>
      <StyledTableCell style={styles.pro} align="center">
        {values[1]}
      </StyledTableCell>
    </StyledTableRow>
  );
};

const styles = {
  pro: {
    fontWeight: "bold",
  },
};
